import React from 'react';
import './avatar_initials.ui.scss';

interface IAvatarInitials {
  name: string;
  size?: number;
}

export const getInitials = (name: string): string => {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (!words.length) return '?';
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
};

const AvatarInitials = (props: IAvatarInitials) => {
  const { name, size = 32 } = props;

  return (
    <span
      className="avatar_initials"
      style={{ width: size, height: size, fontSize: Math.round(size * 0.36) }}>
      {getInitials(name)}
    </span>
  );
};

export default AvatarInitials;
